import { createMeta } from "../../../components/TapHeader";

const title = "Reports";
export const OrgReportsMeta = createMeta(title);
